<template>
  <div class="mb-10 showing-booked-activities">
    <div class="stakeholders showing-customer shadow mb-20">
      <span class="prio-wrap shadow" @click="editPrio(getStakeholder)"><i class="prio-icon flex-inline" :class="prioClass(getStakeholder)"></i></span>
      <Customer v-for="customer in activity.customers"
                v-bind:customer="customer"
                v-bind:customers="activity.customers"
                v-bind:activityShowing="activity.activityShowing"
                v-bind:showingId="showingId"
                v-bind:key="customer.id"
                v-bind:hasMany="activity.customers.length > 1">
      </Customer>
    </div>
  </div>
</template>

<script>
import Customer from './Customer';
import CustomerEditPrio from './CustomerEditPrio';

export default {
  name: 'ShowingActivity',
  components: {Customer},
  props: {
    activity: {
      type: Object,
    },
    showingId: {
      type: Number,
    },
  },
  methods: {
    editPrio() {
      this.$store.commit('STORE_ACTIVE_COMPONENT', CustomerEditPrio);
      this.$root.modalOpen = true;
      this.$store.commit("showing/SET_CUSTOMER_EDIT_PRIO", this.getStakeholder);
    },
    /**
     * Return proper classes based upon prio from 0-6
     */
    prioClass() {
      if (this.getStakeholder.deleted) {
        return "icon-prio-filled-red"
      }
      switch(this.getStakeholder.priority) {
        case 6:
          return "icon-prio-star icon--orange"
        case 5:
          return "icon-prio-star icon--blue"
        case 4:
          return "icon-prio-filled"
        case 3:
          return "icon-prio-three-quarters"
        case 2:
          return "icon-prio-half"
        case 1:
          return "icon-prio-one-quarter"
        default:
          return "icon-prio-reset"
      }
    },
  },
  computed: {
    getStakeholder() {
      let stakeholder ={
        id: this.activity.stakeholderGroup,
        priority: this.activity.priority,
        deleted: this.activity.deleted,
        stakeholders: []
      }

      this.activity.customers.forEach((customer) => {
        stakeholder.stakeholders.push(customer)
      })

      return stakeholder;
    },
  }
};
</script>

<style scoped>
.stakeholders .prio-wrap {
  position: relative;
}
</style>
